export function useIsSimulator() {  
    if (typeof __DEV__ !== 'undefined') {
        return Boolean(__DEV__);
    }
    return false;
}
  